import { useState } from 'react'
import { Routes, Route } from 'react-router-dom'
import { Layout } from './components/Layout'
import { SecurityGate } from './components/SecurityGate'
import { Dashboard } from './pages/Dashboard'
import { AssetEvaluation } from './pages/AssetEvaluation'
import { ConvictionScoring } from './pages/ConvictionScoring'
import { QuantumLearningCurve } from './pages/QuantumLearningCurve'
import { HostileAcquisition } from './pages/HostileAcquisition'
import { KnowledgeBase } from './pages/KnowledgeBase'

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return sessionStorage.getItem('stratos_authenticated') === 'true'
  })

  if (!isAuthenticated) {
    return <SecurityGate onAuthenticated={() => setIsAuthenticated(true)} />
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/asset-evaluation" element={<AssetEvaluation />} />
        <Route path="/conviction-scoring" element={<ConvictionScoring />} />
        <Route path="/quantum-learning-curve" element={<QuantumLearningCurve />} />
        <Route path="/hostile-acquisition" element={<HostileAcquisition />} />
        <Route path="/knowledge-base" element={<KnowledgeBase />} />
        <Route path="*" element={
          <div className="flex items-center justify-center h-64">
            <div className="text-center">
              <h2 className="text-2xl font-bold text-gray-900 mb-2">Page Not Found</h2>
              <p className="text-gray-600">The requested page could not be found.</p>
            </div>
          </div>
        } />
      </Routes>
    </Layout>
  )
}

export default App